import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NoResultsComponent } from './components/no-results/no-results.component'

@NgModule({
  declarations: [NoResultsComponent],
  imports: [CommonModule],
  exports: [NoResultsComponent]
})
export class NoResultsModule {}
